// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import { Button, Tooltip } from "antd";
import { WorkerStages, WorkerSubstages } from "@src/appV2/redesign/utils/worker";
import { useGetBasketSizeLimitConfiguration } from "@src/appV2/Worker/api/useGetBasketSizeLimitConfiguration";
const BUTTON_NAMES = {
  [WorkerStages.ONBOARDING]: "Onboarding",
  [WorkerStages.ENROLLED]: "Enrolled",
  [WorkerStages.RESTRICTED]: "Restricted",
  [WorkerStages.DEACTIVATED]: "Deactivated",
  [WorkerStages.DELETION_REQUESTED]: "Deletion Requested",
  [WorkerStages.SOFT_DELETED]: "Deleted",
  [WorkerSubstages.LIMITED]: "Limited",
  [WorkerSubstages.WARNING]: "Warning",
  [WorkerSubstages.INVITE_REQUIRED]: "Invite-Required",
};

function getStageTooltip(disabled: boolean) {
  if (!disabled) {
    return "";
  }

  return "You do not have permission to change the account status. Please contact an administrator for assistance.";
}

function getButtonType(
  selectedStage: keyof typeof WorkerStages,
  aStage: keyof typeof WorkerStages
) {
  if ([WorkerStages.DELETION_REQUESTED, WorkerStages.SOFT_DELETED].includes(aStage)) {
    return "danger";
  }

  if (selectedStage === aStage) {
    return "primary";
  }

  return "default";
}

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'selectedStage' implicitly has an 'any' type.
function WorkerStagesButtonGroup({ selectedStage, onSelected, disabled }) {
  const toolTipTitle = getStageTooltip(disabled);
  const { limited, warning } = useGetBasketSizeLimitConfiguration();

  const stages = [
    WorkerStages.ONBOARDING,
    ...(limited.enabled ? [WorkerSubstages.LIMITED] : []),
    WorkerStages.ENROLLED,
    ...(warning.enabled ? [WorkerSubstages.WARNING] : []),
    WorkerStages.RESTRICTED,
    WorkerSubstages.INVITE_REQUIRED,
    WorkerStages.DEACTIVATED,
    WorkerStages.DELETION_REQUESTED,
    WorkerStages.SOFT_DELETED,
  ];

  return (
    <Button.Group
      data-testid="worker-stages-button-group"
      aria-label={`Worker stage is ${selectedStage}`}
    >
      {stages
        .filter((stage) => {
          // show the deleted stage only when the worker account is already deleted
          if (selectedStage !== WorkerStages.SOFT_DELETED && stage === WorkerStages.SOFT_DELETED) {
            return false;
          }
          // show the deletion requested stage only when the worker account has a deletion requested
          if (
            selectedStage !== WorkerStages.DELETION_REQUESTED &&
            stage === WorkerStages.DELETION_REQUESTED
          ) {
            return false;
          }
          return true;
        })
        .map((stage) => (
          <Tooltip placement="bottom" title={toolTipTitle} key={stage}>
            <Button
              /* @ts-expect-error 'danger' should be available but it's not */
              type={getButtonType(selectedStage, stage)}
              onClick={() => selectedStage !== stage && onSelected(stage)}
              disabled={disabled && selectedStage !== stage}
            >
              {BUTTON_NAMES[stage]}
            </Button>
          </Tooltip>
        ))}
    </Button.Group>
  );
}

export { WorkerStagesButtonGroup };
